import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum CompanyStatusIds {
  PROPECT = 1,
  CUSTOMER = 2,
  FIRED = 3,
  KAPUT = 4,
}

export function getCompanyStatii(): ISelectItem[] {
  return [
    { id: CompanyStatusIds.PROPECT, label: 'Prospect' },
    { id: CompanyStatusIds.CUSTOMER, label: 'Customer' },
    { id: CompanyStatusIds.FIRED, label: 'Fired' },
    { id: CompanyStatusIds.KAPUT, label: 'Kaput' },
  ]
}

export const getCompanyStatusByLabel = getItemByLabelFactory(getCompanyStatii)
export const getCompanyStatusById = getItemByIdFactory(getCompanyStatii)
